<template>
  <div ref="formField" class="mdc-form-field">
    <div ref="checkbox" class="mdc-checkbox">
      <input type="checkbox" class="mdc-checkbox__native-control" :id="checkboxId" :value="value" @input="onChange">
      <div class="mdc-checkbox__background">
        <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
          <path
            class="mdc-checkbox__checkmark-path"
            fill="none"
            d="M1.73,12.91 8.1,19.28 22.79,4.59"
          ></path>
        </svg>
        <div class="mdc-checkbox__mixedmark"></div>
      </div>
    </div>
    <label v-html="label" :for="checkboxId"></label>
  </div>
</template>

<script>
import { MDCFormField } from "@material/form-field";
import { MDCCheckbox } from "@material/checkbox";
import uuid from 'uuid';

export default {
  props: ["value", "label"],
  mounted() {
    this.checkbox = new MDCCheckbox(this.$refs.checkbox);
    const formField = new MDCFormField(this.$refs.formField);
    formField.input = this.checkbox;
  },
  data() {
      return {
          checkboxId: uuid.v4(),
          checkbox: {}
      }
  },
  methods: {
    onChange() {
      this.$emit('input',this.checkbox.checked);
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Checkbox.vue